export default "__VITE_ASSET__1axQAv1h__"